// eslint-disable-next-line @typescript-eslint/no-empty-function
export var defaultChangeHandler = function defaultChangeHandler() {};

var isFocusEvent = function isFocusEvent(event) {
  return event.target !== undefined || 'target' in event;
};

export var clearValue = function clearValue(e) {
  if (isFocusEvent(e)) {
    e.target.value = '';
  } else {
    e.currentTarget.value = '';
  }
};
/**
 * Добавляет label в items в зависимости от locale
 * @param items
 * @param translations
 */

export var setLabelByValue = function setLabelByValue(items, translations) {
  var results = []; // eslint-disable-next-line no-plusplus

  for (var i = 0; i < items.length; i++) {
    results.push({
      label: "".concat(translations.titleShow, " ").concat(translations.titleBy, " ").concat(items[i]),
      value: items[i]
    });
  }

  return results;
};
export var pluralize = function pluralize(count, words) {
  if (count % 10 === 1 && count % 100 !== 11) return words[0];

  if (count % 10 >= 2 && count % 10 <= 4 && (count % 100 < 10 || count % 100 >= 20)) {
    return words[1];
  }

  return words[2];
};
export var determineTranslationType = function determineTranslationType(translation, count) {
  return typeof translation === 'string' ? translation : translation(count);
};